
import LargeCard from '../cards/largeCard.vue'

import smallCardAlt from '../cards/smallCardAlt.vue'
import PaginationDefault from '../pagination/paginationDefault.vue'
export default {
  components: { smallCardAlt, PaginationDefault, LargeCard },
    name:"exploreResultsDefault",
    props:{
        content: Object,
        useSearch: Boolean,
        placeholder: String,
        restrict: Boolean
    },
    data()
    {
        return{
            filters: [],
            relatedItems: {},
            largeCard: {}
        } 
    },
    mounted()
    {
        console.log("fetching");
            let self = this;

                self.placeholder = "Searching...";
                let query = self.$route.query.q;

                let $tags = [];

                if (self.content && self.content.tags && self.content.tags.length > 0 && self.content.tags[0] != undefined)
                {
                    console.log(self.content.tags.split);
                    $tags = self.content.tags.split(', ');
                }


                self.$axios.$post('/.netlify/functions/kirby',
                    {
                        "q": query,
                        "tags" : $tags
                    }, {
                        baseURL: "",
                        auth: "",                                
                        headers: {
                            common: {
                            Authorization: ''
                            }
                        },
                        config: {
                            auth: ""
                        }
                    }
                ).then(resp => {            
                    let $items = resp.pages;

                    if ($items)
                    { 
                        self.relatedItems = $items;
                    }
                    let  $largecard = resp.pages;  
                    self.largeCard = $largecard;
                    self.placeholder = ""; 

                    if (resp.pages)
                    {
                    let resultsCount = resp.pages.length; 

                    if (dataLayer && query){
                        dataLayer.push({'search_term': query});
                        dataLayer.push({'num_search_results': resultsCount});
                    }
                    }

                })
        
    },
    async fetch()
    { 
        if (process.server)
        {
        let self = this;
        let $searchQuery = "";  
        if (this.$route && this.$route.query.q != null)
        {
            $searchQuery = this.$route.query.q;
        }

        let $tags = [];

        if (this.content && this.content.tags && this.content.tags.length > 0 && this.content.tags[0] != undefined)
        {
            console.log(this.content.tags.split);
            $tags = this.content.tags.split(', ');
        }
 
        let $items = {'empty' : ''};
        let $largecard = {};

        await this.$axios.$post('getrelated', {
            "tags" : $tags,
            "q" :  $searchQuery
            })
            .then(resp => {
                $items = resp.pages;
                $largecard = resp.pages;
                this.largeCard = $largecard;
                this.relatedItems = $items;
            })
            .catch(error => {
                if (error.response) { 
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                } else if (error.request) {
                    // The request was made but no response was received
                    console.log(error.request);
                } else {
                // Something happened in setting up the request that triggered an Error
                    console.log('Error', error.message);
                }            
                return self.$nuxt.error({ statusCode: 404, message: error.message })	
            }); 
        }
    },
  errorCaptured(err, vm, info) {
      console.log("hero error", err, vm, info);
    // err: error trace
    // vm: component in which error occured
    // info: Vue specific error information such as lifecycle hooks, events etc.
    // TODO: Perform any custom logic or log to server
    // return false to stop the propagation of errors further to parent or global error handler
  }
}
